export default __webpack_public_path__ + "static/media/more-black.de42e128.svg";